export default "__VITE_ASSET__07c8103c__"